import { ReactComponent as F1CalendarIcon } from '@eti/assets/icons/revolut/calendar.svg';
import { css, cx } from '@eti/styles';
import { vars } from '@etg/wings';

const wrapperStyles = css`
  display: flex;
  flex: 1;
  position: relative;

  &::before {
    border: 0.1875rem solid ${vars.colors.inputs.focus};
    border-radius: 0.375rem;
    content: '';
    height: calc(100% + 0.375rem);
    left: -0.1875rem;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: -0.1875rem;
    transition: opacity 0.2s ease-in-out;
    width: calc(100% + 0.375rem);
  }

  &:focus-within {
    z-index: 1;
  }

  &:focus-within::before {
    opacity: 1;
  }
`;

const triggerStyles = css`
  align-items: center;
  appearance: none;
  background-color: ${vars.colors.inputs.background};
  border-color: ${vars.colors.inputs.border};
  border-radius: ${vars.inputs.borderRadius};
  border-style: solid;
  border-width: 0.0625rem;
  color: inherit;
  display: flex;
  font-family: inherit;
  font-size: 1rem;
  height: ${vars.inputs.height};
  justify-content: space-between;
  outline: none;
  padding-inline: ${vars.inputs.paddingInline};
  position: relative;
  -webkit-tap-highlight-color: transparent;
  text-align: start;
  width: 100%;

  &:focus {
    border-color: ${vars.colors.inputs.borderFocused};
  }
`;

const triggerWithIconStyles = css`
  cursor: pointer;
  padding-inline: ${vars.inputs.floatingLabel.paddingInlineStartWithIcon}
    ${vars.inputs.iconInsetMargin};
`;

const labelStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const iconStyles = css`
  fill: ${vars.colors.text.secondary};
  height: auto;
  inset-inline-start: ${vars.inputs.iconInsetMargin};
  pointer-events: none;
  position: absolute;
  top: calc(((${vars.inputs.height} - 2px) - ${vars.inputs.iconSize}) / 2);
  width: ${vars.inputs.iconSize};
`;

export interface CalendarToggleProps {
  label: string;
  onClick: () => void;
}

const CalendarToggle = ({ label, onClick }: CalendarToggleProps) => (
  <div className={wrapperStyles}>
    <button
      aria-controls="searchform-dates-selection"
      aria-label={label}
      aria-live="assertive"
      className={cx(triggerStyles, triggerWithIconStyles)}
      data-testid="searchForm-calendar-toggle"
      id="searchForm-calendar-toggle"
      onClick={onClick}
      type="button"
    >
      <F1CalendarIcon aria-hidden className={iconStyles} />
      <span aria-atomic aria-hidden className={labelStyles}>
        {label}
      </span>
    </button>
  </div>
);

export default CalendarToggle;
